/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDocumentGears = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2h10.414L20 7.586V11h-2V9h-5V4H6v16h6v2H4V2zm11 3.414V7h1.586L15 5.414z"
        fill="currentcolor"
      />
      <path
        d="M22 18.8v-1.6h-.913a3.165 3.165 0 0 0-.34-.816l.647-.646-1.132-1.132-.646.647a3.165 3.165 0 0 0-.816-.34V14h-1.6v.913c-.291.076-.563.19-.816.34l-.646-.647-1.132 1.132.647.646a3.193 3.193 0 0 0-.34.816H14v1.6h.913c.076.291.191.563.34.816l-.647.646 1.13 1.132.648-.647c.253.149.525.264.816.34V22h1.6v-.913c.291-.076.563-.191.816-.34l.646.647 1.132-1.132-.647-.646c.15-.253.264-.525.34-.816H22zm-4 .8a1.6 1.6 0 1 1 .001-3.201A1.6 1.6 0 0 1 18 19.6z"
        fill="currentcolor"
      />
      <path
        d="M15 14.8v-1.6h-.913a3.165 3.165 0 0 0-.34-.816l.647-.646-1.132-1.132-.646.647a3.165 3.165 0 0 0-.816-.34V10h-1.6v.913c-.291.076-.563.19-.816.34l-.646-.647-1.132 1.132.647.646a3.193 3.193 0 0 0-.34.816H7v1.6h.913c.076.291.191.563.34.816l-.647.646 1.13 1.132.648-.647c.253.149.525.264.816.34V18h1.6v-.913c.291-.076.563-.191.816-.34l.646.647 1.132-1.132-.647-.646c.15-.253.264-.525.34-.816H15zm-4 .8a1.6 1.6 0 1 1 .001-3.201A1.6 1.6 0 0 1 11 15.6z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDocumentGears as DocumentGears };
